import { Injectable, inject } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { AwareExtensionProvider } from '@appbolaget/aware-extension';
import { Store } from '@ngxs/store';
import { UnitState } from 'app/state/unit.state';

@Injectable({ providedIn: 'root' })
export class ExtensionProvider implements AwareExtensionProvider {
    private store = inject(Store);

    getUnitId() {
        return this.store.select(UnitState.activeUnit).pipe(
            filter((unit) => (unit && unit.uuid ? true : false)),
            map((unit) => {
                return unit.uuid;
            }),
        );
    }
}
